/* Ayudate · Ajustes de accesibilidad (Accesibilidad.jsx)
   Un solo formato de guardado/lectura para las páginas que ofrecen el
   panel de accesibilidad, así todas comparten la misma clave de
   localStorage y los mismos valores por defecto. */

const CLAVE_A11Y = "ayudate_a11y_ajustes";
const A11Y_PREDETERMINADO = {
  zoom: 100, fuente: false, espaciado: false,
  filtro: "ninguno", contraste: false, enlaces: false, movimiento: false,
};

export function cargarA11y() {
  try {
    const guardado = JSON.parse(localStorage.getItem(CLAVE_A11Y));
    return guardado ? { ...A11Y_PREDETERMINADO, ...guardado } : A11Y_PREDETERMINADO;
  } catch {
    return A11Y_PREDETERMINADO;   // modo privado o cuota llena: sigue funcionando, solo sin persistir
  }
}

export function guardarA11y(a11y) {
  try { localStorage.setItem(CLAVE_A11Y, JSON.stringify(a11y)); } catch { /* seguir sin persistir */ }
}

export function clasesA11y(a11y) {
  return [
    a11y.zoom !== 100 ? `z${a11y.zoom}` : "",
    a11y.fuente ? "fuente-legible" : "",
    a11y.espaciado ? "espaciado" : "",
    a11y.filtro !== "ninguno" ? `f-${a11y.filtro}` : "",
    a11y.contraste ? "contraste" : "",
    a11y.enlaces ? "enlaces" : "",
    a11y.movimiento ? "sinmov" : "",
  ].filter(Boolean).join(" ");
}
